import $ from 'jquery';

const $sticky = $('.js-sticky');
const $stickyStart = $('.js-sticky-start');
const $stickyStop = $('.js-sticky-stop');

if (
  $sticky.length >= 1 &&
  $stickyStart.length >= 1 &&
  $stickyStop.length >= 1
) {
  //

  function update() {
    const windowScrollTop = $(window).scrollTop();
    const windowScrollBottom = windowScrollTop + $(window).height();
    const stickyStartPosition = $stickyStart.offset().top;
    const stickyStopPosition = $stickyStop.offset().top;
    $sticky.css({
      '--sticky-stop-position': `${stickyStopPosition - $sticky.height()}px`,
    });
    $sticky.toggleClass('is-fixed', windowScrollTop > stickyStartPosition);
    $sticky.toggleClass('is-stopped', windowScrollBottom > stickyStopPosition);
  }

  $(window).on('scroll', update);
  $(window).on('resize', update);
  update();
}
